import { Injectable } from '@angular/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { ActionType } from '../enums/action-type.enum';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class UserMessagingService {
  private createSuccessMsg = 'item created successfully';
  private createSuccessMsgAr = 'تمت العملية بنجاح';

  private updateSuccessMsg = 'item updated successfully';
  private updateSuccessMsgAr = 'تمت العملية بنجاح';

  private deleteSuccessMsg = 'item deleted successfully';
  private deleteSuccessMsgAr = 'تم حذف العنصر بنجاح';

  private confirmDeleteMsg = "Are you sure you want to delete this item";
  private confirmDeleteMsgAr = "هل انت متاكد من رغبتك في حذف هذا العنصر";

  private titleConfirmDeleteMsg = "Delete item?";
  private titleConfirmDeleteMsgAr = "حذف العنصر";

  private confirmDeleteBtnText = "Yes, delete it!";
  private confirmDeleteBtnTextAr = "حذف";

  private cancelDeleteBtnText = "Cancel";
  private cancelDeleteBtnTextAr = "الغاء";

  private confirmCompleteMsg = "Are you sure you want to complete this item";
  private confirmCompleteMsgAr = "هل انت متاكد من رغبتك في إتمام هذا العنصر";

  private titleConfirmCompleteMsg = "Complete item?";
  private titleConfirmCompleteMsgAr = "إتمام العنصر";

  private confirmCompleteBtnText = "Yes, complete it!";
  private confirmCompleteBtnTextAr = "إتمام";

  private createErrorMsg = 'Error while creating item';
  private createErrorMsgAr = 'حدث خطأ أثناء إنشاء العنصر';

  private updateErrorMsg = 'Error while updating item';
  private updateErrorMsgAr = 'حدث خطأ أثناء تحديث العنصر';

  private deleteErrorMsg = 'Error while deleting item';
  private deleteErrorMsgAr = 'حدث خطأ أثناء حذف العنصر';

  private titleConfirmMsg = "Confrim Action?";
  private titleConfirmMsgAr = "تاكيد العملية";

  private confirmBtnText = "Yes, Do it!";
  private confirmBtnTextAr = "نعم";

  private confirmMsg = "Are you sure you want to confirm this action";
  private confirmMsgAr = "هل انت متاكد من رغبتك في تاكيد هذه العملية";

  private noCurrentSessionMsg = 'No current session or shift is open, please create one first';
  private noCurrentSessionMsgAr = 'لا توجد جلسة حالية أو وردية مفتوحة، يرجى إنشاء واحدة أولاً';

  private noProductFoundMsg = 'No product has been found';
  private noProductFoundMsgAr = 'لم يتم العثور على صنف';


  showConfirmPopup(
    messageAr: string,
    messageEn: string,
    buttonLabels?: {
      confirmAr: string;
      confirmEn: string;
      cancelAr: string;
      cancelEn: string;
    }
  ): Promise<boolean> {
    const isArabic = this.getCurrentLanguage() === 'ar';

    return new Promise((resolve) => {
      Swal.fire({
        title: isArabic ? this.titleConfirmMsgAr : this.titleConfirmMsg,
        text: isArabic ? messageAr : messageEn,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: buttonLabels
          ? (isArabic ? buttonLabels.cancelAr : buttonLabels.cancelEn)
          : (isArabic ? this.cancelDeleteBtnTextAr : this.cancelDeleteBtnText),
        confirmButtonText: buttonLabels
          ? (isArabic ? buttonLabels.confirmAr : buttonLabels.confirmEn)
          : (isArabic ? this.confirmBtnTextAr : this.confirmBtnText),
      }).then((result) => {
        resolve(result.isConfirmed);
      });
    });
  }

  noProductFound() {
    this.toastr.error(
      this.getCurrentLanguage() === 'ar'
        ? this.noProductFoundMsgAr
        : this.noProductFoundMsg,
      '',
      {
        positionClass: 'toast-center-center',
      }
    );
  }


  showNoCurrentSessionMessage() {
    this.toastr.warning(
      this.getCurrentLanguage() === 'ar'
        ? this.noCurrentSessionMsgAr
        : this.noCurrentSessionMsg
    );
  }

  showWarningToast(message: string): void {
    this.toastr.warning(message, '', {
      positionClass: 'toast-center-center',
    });
  }

  getCurrentLanguage() {
    return this.localizationService.getCachedLanguage();
  }

  createUpdateSuccessMessage(actionType: ActionType) {
    switch (actionType) {
      case ActionType.CREATE:
        this.toastr.success(
          this.getCurrentLanguage() === 'ar'
            ? this.createSuccessMsgAr
            : this.createSuccessMsg
        );
        return;
      case ActionType.UPDATE:
        this.toastr.success(
          this.getCurrentLanguage() === 'ar'
            ? this.updateSuccessMsgAr
            : this.updateSuccessMsg
        );
        return;
    }
  }

  handleErrorMessage(actionType: ActionType) {
    switch (actionType) {
      case ActionType.CREATE:
        this.toastr.error(
          this.getCurrentLanguage() === 'ar'
            ? this.createErrorMsgAr
            : this.createErrorMsg
        );
        return;
      case ActionType.UPDATE:
        this.toastr.error(
          this.getCurrentLanguage() === 'ar'
            ? this.updateErrorMsgAr
            : this.updateErrorMsg
        );
        return;
      case ActionType.DELETE:
        this.toastr.error(
          this.getCurrentLanguage() === 'ar'
            ? this.deleteErrorMsgAr
            : this.deleteErrorMsg
        );
        return;
    }
  }

  createUpdateErrorMessage(errorMessage: string) {
    this.toastr.error(errorMessage);
  }

  deleteSuccessMessage(actionType: ActionType) {
    switch (actionType) {
      case ActionType.DELETE:
        this.toastr.success(
          this.getCurrentLanguage() === 'ar'
            ? this.deleteSuccessMsgAr

            : this.deleteSuccessMsg
        );
        return;
    }
  }

  confirmMessageModal(callbackFn: Function) {
    Swal.fire({
      title: this.getCurrentLanguage() === 'ar' ? this.titleConfirmDeleteMsgAr : this.titleConfirmDeleteMsg,
      text: this.getCurrentLanguage() === 'ar' ? this.confirmDeleteMsgAr : this.confirmDeleteMsg,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: this.getCurrentLanguage() === 'ar' ? this.cancelDeleteBtnTextAr : this.cancelDeleteBtnText,
      confirmButtonText: this.getCurrentLanguage() === 'ar' ? this.confirmDeleteBtnTextAr : this.confirmDeleteBtnText,
    }).then((result) => {
      if (result.isConfirmed) {
        callbackFn();
      }
    });
  }

  confrmMessageModal(callbackFn: Function, cancelFn: Function) {
    const title = this.getCurrentLanguage() === 'ar' ? this.titleConfirmMsgAr : this.titleConfirmMsg;
    const text = this.getCurrentLanguage() === 'ar' ? this.confirmMsgAr : this.confirmMsg;
    const confirmButtonText = this.getCurrentLanguage() === 'ar' ? this.confirmBtnTextAr : this.confirmBtnText;

    Swal.fire({
      title: title,
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: this.getCurrentLanguage() === 'ar' ? this.cancelDeleteBtnTextAr : this.cancelDeleteBtnText,
      confirmButtonText: confirmButtonText,
    }).then((result) => {
      if (result.isConfirmed) {
        callbackFn();
      } else {
        cancelFn();
      }
    });

  }

  confrmMessageModalNotDelete(callbackFn: Function, cancelFn: Function) {
    const title = this.getCurrentLanguage() === 'ar' ? this.titleConfirmMsgAr : this.titleConfirmMsg;
    const text = this.getCurrentLanguage() === 'ar' ? this.confirmMsgAr : this.confirmMsg;
    const confirmButtonText = this.getCurrentLanguage() === 'ar' ? this.confirmBtnTextAr : this.confirmBtnText;

    Swal.fire({
      title: title,
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: this.getCurrentLanguage() === 'ar' ? this.cancelDeleteBtnTextAr : this.cancelDeleteBtnText,
      confirmButtonText: confirmButtonText,
    }).then((result) => {
      if (result.isConfirmed) {
        callbackFn();
      } else {
        cancelFn();
      }
    });
  }

  confirmDeleteMessageModal(callbackFn: Function) {
    const title = this.getCurrentLanguage() === 'ar' ? this.titleConfirmDeleteMsgAr : this.titleConfirmDeleteMsg;
    const text = this.getCurrentLanguage() === 'ar' ? this.confirmDeleteMsgAr : this.confirmDeleteMsg;
    const confirmButtonText = this.getCurrentLanguage() === 'ar' ? this.confirmDeleteBtnTextAr : this.confirmDeleteBtnText;

    Swal.fire({
      title: title,
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: this.getCurrentLanguage() === 'ar' ? this.cancelDeleteBtnTextAr : this.cancelDeleteBtnText,
      confirmButtonText: confirmButtonText,
    }).then((result) => {
      if (result.isConfirmed) {
        callbackFn();
      }
    });
  }

  confirmCompleteMessageModal(callbackFn: Function) {
    const title = this.getCurrentLanguage() === 'ar' ? this.titleConfirmCompleteMsgAr : this.titleConfirmCompleteMsg;
    const text = this.getCurrentLanguage() === 'ar' ? this.confirmCompleteMsgAr : this.confirmCompleteMsg;
    const confirmButtonText = this.getCurrentLanguage() === 'ar' ? this.confirmCompleteBtnTextAr : this.confirmCompleteBtnText;

    Swal.fire({
      title: title,
      text: text,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: this.getCurrentLanguage() === 'ar' ? this.cancelDeleteBtnTextAr : this.cancelDeleteBtnText,
      confirmButtonText: confirmButtonText,
    }).then((result) => {
      if (result.isConfirmed) {
        callbackFn();
      }
    });
  }



  constructor(
    private localizationService: LocalizationService,
    private toastr: ToastrService
  ) { }
}
